import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Nicole Bragg",
    role: "Ray White, Edge Hill — Cairns",
    rating: 5,
    quote:
      "Working with a wide range of buyers agents, you quickly learn who genuinely advocates for their clients, and Rob is absolutely one of those standouts. Rob continuously goes above and beyond. He'll pick up the phone after hours, chase opportunities that others might miss, and put in the legwork required to secure the right property for his buyers. His knowledge of the market is solid, his instincts are sharp, and he has a genuine ability to spot value and opportunity early. What truly sets Rob apart is the way he builds relationships. He treats agents with respect, communicates clearly, and works collaboratively, which in turn opens doors to off-market and pre-market opportunities for his clients. That sort of access only comes when a buyer's agent has earned trust, and Rob has certainly done that. His tenacity, professionalism, and work ethic make him a pleasure to deal with. If you're looking for a buyer's agent who genuinely works hard, acts with heart, and will push to create the best possible outcomes for his clients, Rob is a great buyer's agent."
  },
  {
    name: "Jenny & Zane",
    role: "First Home Buyers — Brisbane",
    rating: 5,
    quote:
      "Buying our first home felt overwhelming at times, but Rob was there every step of the way. He's incredibly direct and honest, which is exactly what you need when making such a big decision. He never told us what we wanted to hear — he told us what we needed to hear, always with our best interests at heart. Rob's understanding of the market, buyer psychology and competition helped us make confident decisions, even when things felt challenging. His guidance, patience and genuine care made a huge difference to our experience, and I can honestly say we wouldn't be in our beautiful new home without him. I couldn't recommend him more highly."
  },
  {
    name: "Tony & Lilly",
    role: "Home Buyers — Sunshine Coast",
    rating: 5,
    quote:
      "We recently had the pleasure of working with Rob for the purchase of our acreage property on the Sunshine Coast, and we couldn't recommend him more highly. From the outset, Rob's knowledge of the market and the buying process gave us confidence that we were making informed decisions. He provided honest, strategic advice throughout the negotiations and offered valuable insights that we simply wouldn't have had on our own. If you're looking for someone who is professional, highly knowledgeable and genuinely invested in helping you make the right decision, we would have no hesitation in recommending Rob."
  }
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#0E1612] border-t border-neutral-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-7">
            <p className="overline mb-4">What the industry says</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
              Trusted by the agents <br />
              who <span className="italic text-[#36C281]">open the doors</span>.
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-neutral-400 leading-relaxed self-end">
            Access to off-market and pre-market property is earned, not bought. Here's what
            local selling agents say about working with Rob.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="relative border border-neutral-800 bg-[#0A100D] p-8 md:p-12 hover:border-[#36C281]/40 transition-colors duration-300"
            >
              <Quote
                size={48}
                strokeWidth={1.2}
                className="text-[#36C281]/30 mb-6"
                aria-hidden="true"
              />

              <div
                className="flex items-center gap-1 mb-7"
                data-testid={`testimonial-rating-${i}`}
                aria-label={`${t.rating} out of 5 stars`}
              >
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={18} className="text-[#36C281] fill-[#36C281]" />
                ))}
              </div>

              <blockquote className="font-serif-display text-xl md:text-2xl leading-relaxed text-neutral-100">
                "{t.quote}"
              </blockquote>

              <figcaption className="mt-10 flex items-center gap-4">
                <span className="w-12 h-12 rounded-full bg-[#36C281]/15 border border-[#36C281]/40 flex items-center justify-center font-serif-display text-lg text-[#36C281]">
                  {t.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </span>
                <span>
                  <span className="block font-medium text-[#EFE9D4]" data-testid={`testimonial-name-${i}`}>
                    {t.name}
                  </span>
                  <span className="block text-sm text-neutral-400" data-testid={`testimonial-role-${i}`}>
                    {t.role}
                  </span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
